

    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion} from './controlador';
    import { Item } from '@/__env/lib/Ventas/Pedidos/Item';
    import { Observacion } from '@/__env/lib/Ventas/Pedidos/Observaciones';
    import { Wait } from '@/__env/ext';
    import { utimes } from 'fs';
    import { Utiles } from '@/__env/pluggins/event-bus';
import { UsuarioActual } from '@/views/a-login/login-controlador';
    @Component( {
        name: "Componente",
        props: {},
        components: {
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorSeccion;
        public get Pedido() { return this.Controlador.Pedido; }
        public get Estado() { return this.Controlador.Vista.Estado; }
        public get Cliente() { return this.Controlador.Pedido.Cliente; }
        public get Envio() { return this.Controlador.Pedido.Envio; }

        public Focused: boolean = false;
        public Cargando: boolean = false;
        public Observaciones: Observacion[] = [];

        public Observacion: string = '';

        async mounted()
        {
            this.Cargando = true;
            await Wait( 2000 );
            this.Observaciones.clear();
            //this.Observaciones = await this.Pedido.CargarObservaciones();
            this.Cargando = false;
            this.$nextTick( () => Utiles.ElementScrollBottom( document.getElementById( 'div-observaciones' ) ) );
        }

        Cerrar()
        {
            this.Focused = false;
        }

        async Enviar()
        {
            if ( this.Observacion )
            {
                let o = this.Observacion;
                this.Observacion = '';
                let ob = new Observacion();
                ob.Observacion = o;
                ob.Usuario.Nombre = UsuarioActual.Nombre;
                ob.Pedido = this.Pedido.Id;
                this.Observaciones.push( ob );
                this.Pedido.Observaciones.push( ob );
            }
        }
    }
